import { CategoryTiles } from '../src/components/CategoryTiles/CategoryTiles';
import { CategoryRooms } from '../src/components/CategoryRooms/CategoryRooms';

export { CategoryTiles, CategoryRooms };
